import { render, staticRenderFns } from "./AlbumsList.vue?vue&type=template&id=7f749ccc"
import script from "./AlbumsList.vue?vue&type=script&lang=js"
export * from "./AlbumsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports